"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UnlessCondition {
    constructor(expression) {
        this.expression = expression;
    }
    shouldDoValidation(input) {
        return !this.expression(input);
    }
}
exports.UnlessCondition = UnlessCondition;
//# sourceMappingURL=UnlessCondition.js.map